import React from 'react';
import './UsLandingSection.css';

const UsLandingSection = () => {
  return (
    <div className="us-landing-container">
      <h1 className="us-landing-titulo">Thorne Global: Tu Puerta de Entrada al Mercado de Dubái</h1>
      <p className="us-landing-subtitulo">
        ESPECIALISTAS EN CONECTAR A INVERSORES DE TODO EL MUNDO CON LAS OPORTUNIDADES ÚNICAS DE DUBÁI. NUESTRO EQUIPO COMBINA EXPERIENCIA LOCAL CON UNA VISIÓN GLOBAL, PROPORCIONANDO ASESORAMIENTO ESTRATÉGICO EN BIENES RAÍCES, DESDE PROYECTOS OFF-PLAN HASTA PROPIEDADES LISTAS PARA HABITAR O RENTAR. TE AYUDAMOS A TOMAR DECISIONES INFORMADAS Y A APROVECHAR AL MÁXIMO EL DINAMISMO DEL MERCADO EMIRATÍ.
      </p>
    </div>
  );
};

export default UsLandingSection;